import React from 'react';
import { styled } from "../../../stitches.config";
import { observer } from 'mobx-react'

import img1 from "./Issue5418/img1.png"
import img2 from "./Issue5418/img2.png"
import img3 from "./Issue5418/img3.png"
import img4 from "./Issue5418/img4.png"
import img5 from "./Issue5418/img5.png"
import img6 from "./Issue5418/img6.png"

import bombRed from "./Issue5418/bomb-red.png"
import bombBlue from "./Issue5418/bomb-blue.png"
import bombWhite from "./Issue5418/bomb-white.png"

import mobile from "./Issue5418/background-mobile.jpeg"
import desktop from "./Issue5418/background-desktop.jpeg"

import "animate.css/animate.min.css";

// specjalna animacja dla artykułu premium z zadania #5418

const ParagraphIssue5418 = observer(({ paragraph }) => {

    return (
        <Wrapper>
            <img class="img1 animate__animated animate__fadeIn" src={img1} />
            <img class="img2 animate__animated animate__fadeIn" src={img2} />
            <img class="img3 animate__animated animate__fadeIn" src={img3} />
            <img class="img4 animate__animated animate__fadeIn" src={img4} />
            <img class="img5 animate__animated animate__fadeInLeft" src={img5} />
            <img class="img6 animate__animated animate__fadeInLeft" src={img6} />
            <ImgWrapper>
                <img class="bomb1 animate__animated animate__fadeInTopRight" src={bombRed} />
                <img class="bomb2 animate__animated animate__fadeInTopRight" src={bombBlue} />
                <img class="bomb3 animate__animated animate__fadeInTopRight" src={bombWhite} />
            </ImgWrapper>
        </Wrapper>
    )
})

const Wrapper = styled("div", {
    backgroundImage: `url("${mobile}")`,
    backgroundPosition: "top center",
    backgroundSize: "contain",
    backgroundRepeat: "no-repeat",
    width: "100%",
    height: "405px",
    position: "relative",
    overflow: "hidden",
    backgrounColor: "#e9e8e2",
    "@media (min-width: 450px)": {
        height: "600px"
    },
    "@bp4": {
        backgroundSize: "cover",
        backgroundImage: `url("${desktop}")`,
        height: "1080px"
    },
    "@media (min-width: 1920px)": {
        backgroundSize: "contain"
    },
    "img": {
        display: "none",
        "@bp4": {
            display: "block",
            position: "absolute"
        }
    },
    /* Ustawienie pozycji animowanych zdjęć */
    ".img1": {
        width: "245px",
        top: "432px",
        right: "calc(50% - 600px)",
        zIndex: 2,
        animationDelay: "1s",
        animationDuration: "3s"
    },
    ".img2": {
        width: "327px",
        top: "716px",
        zIndex: 3,
        right: "calc(50% - 560px)",
        animationDelay: "1s",
        animationDuration: "3s"
    },
    ".img3": {
        width: "158px",
        top: "840px",
        zIndex: 3,
        left: "calc(50% - 40px)",
        animationDelay: "1s",
        animationDuration: "3s"
    },
    ".img4": {
        width: "597px",
        top: "530px",
        left: "calc(50% - 260px)",
        zIndex: 2,
        animationDelay: "1s",
        animationDuration: "3s"
    },
    ".img5": {
        width: "1144px",
        left: "calc(50% - 640px)",
        top: "75px",
        animationDuration: "4s"
    },
    ".img6": {
        width: "554px",
        top: "424px",
        left: "calc(50% - 780px)",
        animationDelay: "1s",
        animationDuration: "4s"
    }
});

const ImgWrapper = styled("div", {
    display: "none",
    "@bp4": {
        display: "block",
        position: "absolute",
        top: "72px",
        width: "200px",
        height: "216px",
        right: "calc(50% - 540px)"
    },
    ".bomb1": {
        right: 0,
        top: 0,
        animationDuration: "3s"
    },
    ".bomb2": {
        left: 0,
        bottom: 0,
        animationDelay: "0.25s",
        animationDuration: "3s"
    },
    ".bomb3": {
        left: "80px",
        bottom: 0,
        animationDelay: "0.5s",
        animationDuration: "3s"
    }
});

export default ParagraphIssue5418;